const SEO = [
	{
		page: "home",
		description:
		"I am 5th year Ph.D. candidate in School of Cyber Security & Privacy and Department of Electrical & Computer Engineering at Georgia Institute of Technology. I work in Cyber Forensics Innovation (CyFI) Lab, advised by Prof. Brendan Saltaformaggio.\\	My research lies in binary analysis, botnet remediation, advertisement fraud detection, and large-scale cyber attack metigation.",
		keywords: ["Runze Zhang"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Tharindu", "Tharindu N", "Tharindu Nayanajith"],
	},

	{
		page: "publications",
		description:
			"A collection of my publications.",
		keywords: ["Runze Zhang", "DVa", "Coco", "Glean", "Hitchhiking Vaccine", "Botnet", "Advertisement Fraud", "Cyber Security", "Cyber Forensics"],
	},
	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Runze Zhang"],
	},
	{
		page: "projects",
		description:
			"A collection of my projects.",
		keywords: ["Runze Zhang", "Projects"],
	},
];

export default SEO;
